module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "ill001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ill-001"
    }
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "con1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INSETS")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ins01"
    }
  }, [_vm._v("How This Book Refers to God")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ins02"
    }
  }, [_vm._v("Readings from the Revised Common Lectionary")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins03"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ins03"
    }
  }, [_vm._v("Meanings of “Israel”")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins04"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ins04"
    }
  }, [_vm._v("An Archaeological Timeline")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins05"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ins05"
    }
  }, [_vm._v("A Historical Timeline")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins06"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ins06"
    }
  }, [_vm._v("A Literary Timeline")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ins07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Law Collections of the Ancient Near East")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins08"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ins08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ten Commandments")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins09"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ins09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditions for Dividing the Ten Commandments in Exodus")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ins10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Motive Clauses")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ins11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Organization of the Decalogue in Exodus and Deuteronomy")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ins12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Opening Formulas in Northwest Semitic Royal Inscriptions")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ins13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parallels between the Decalogue and Deuteronomic Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ins14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Threats of Collective Punishment in Loyalty Oaths")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ins15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Organization of Exodus 20:23–23:19")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ins16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Organization of the Case Laws in Exodus 21:18–22:17")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ins17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mesopotamian Laws about Goring Oxen")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#ins18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laws of Hammurabi §117")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#ins19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laws of Hammurabi §115")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#ins20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Model for Development of P and H in Exodus–Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#ins21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Structure of the Tabernacle Laws in Exodus")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#ins22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Organization of Exodus 25–31")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#ins23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plan of the Tabernacle")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#ins24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Regions of Graded Holiness in the Tabernacle")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#ins25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Typology of Sacrificial Actions")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#ins26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Structure of Leviticus 1–7")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#ins27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classification of Priestly Sacrifices by Mode of Consumption")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#ins28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Death Penalty in Biblical Law")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015#ins29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Structure of Leviticus 11")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015#ins30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Structure of Numbers 19")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015#ins31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Structure of Leviticus 15")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015#ins32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Structure of Leviticus 12")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016#ins33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major Polar Values in Priestly Thinking")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016#ins34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Contents of Leviticus 18 and 20")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016#ins35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Variations in the Assessment of Sexual Relations in Biblical Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016#ins36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Categories of Polar Thinking in Leviticus 19")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter017#ins37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Structure of Leviticus 25")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018#ins38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Meaning of “Deuteronomy”")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018#ins39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Treaty Formulary in Biblical Texts")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018#ins40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Examples of Deuteronomic Rhetoric")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018#ins41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parallels between Deuteronomy and Esarhaddon’s Succession Treaty")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018#ins42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Torah Scrolls in the Dead Sea Scrolls")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter019#ins43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Structure of Deuteronomy 7")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter019#ins44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reasons for the Destruction of Canaan and Israel/Judah")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter020#ins45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cases of Deuteronomy’s Dependence on Law in the Covenant Code")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter020#ins46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cultic Centralization Laws in Deuteronomy 12–26")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter021#ins47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Organization of Deuteronomy 16:18–18:22")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter021#ins48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Literary Organization in Deuteronomy 19–25")])]), _vm._v(" "), _c('p', {
    staticClass: "con2b",
    attrs: {
      "id": "ins49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter022#ins49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Organization of Deuteronomy 22:13–29")])]), _vm._v(" "), _c('p', {
    staticClass: "con1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIGURES")])]), _vm._v(" "), _c('p', {
    staticClass: "con2",
    attrs: {
      "id": "fig001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter003#fig001"
    }
  }, [_vm._v("Figure 1. Mosaic picturing Moses")])]), _vm._v(" "), _c('p', {
    staticClass: "con2",
    attrs: {
      "id": "fig002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#fig002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 2. Shamash bestowing symbols of royal authority on Hammurabi")])]), _vm._v(" "), _c('p', {
    staticClass: "con2",
    attrs: {
      "id": "fig003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#fig003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3. Kulamuwa inscription")])]), _vm._v(" "), _c('p', {
    staticClass: "con2",
    attrs: {
      "id": "fig004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#fig004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4. Beersheba altar")])]), _vm._v(" "), _c('p', {
    staticClass: "con2",
    attrs: {
      "id": "fig005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#fig005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 5. Megiddo ivory")])]), _vm._v(" "), _c('p', {
    staticClass: "con2",
    attrs: {
      "id": "fig006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#fig006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6. "), _c('i', [_vm._v("Mizrāq")]), _vm._v(" from Tel Dan")])]), _vm._v(" "), _c('p', {
    staticClass: "con2",
    attrs: {
      "id": "fig007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015#fig007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7. Relief from the palace of Assurnasirpal II")])]), _vm._v(" "), _c('p', {
    staticClass: "con2",
    attrs: {
      "id": "fig008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter017#fig008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 8. Dove of peace playing the shofar")])]), _vm._v(" "), _c('p', {
    staticClass: "con2",
    attrs: {
      "id": "fig009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018#fig009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 9. Esarhaddon’s Succession Treaty")])]), _vm._v(" "), _c('p', {
    staticClass: "con2a",
    attrs: {
      "id": "fig010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter020#fig010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 10. Standing stone and incense altars at Tel Arad")])]), _vm._v(" "), _c('p', {
    staticClass: "con2a",
    attrs: {
      "id": "fig011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter021#fig011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 11. Plan of Iron Age Beersheba")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be3f3abe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/illustrations.vue
// module id = 69
// module chunks = 0